<template lang="pug">
  .width-100.m-top-1.m-bottom-2
    button.row.middle.m-bottom-2(@click='$emit("back")')
      button.m-right-05
        simple-svg.blue-icon(:filepath='leftArrow' width='20px' height='20px')
      h2.text-normal.blue.bold {{ $t('shareResource.back') }}
    .column.start.m-bottom-2
      h2.text-normal.m-bottom-1 {{ $t('shareResource.selectClasses') }}
      .row.classes
        .class-select.middle
          checkbox.m-right-05(:updateCheck='toggleAll' :checked='allSelected')
          h2.text-normal.blue.bold {{ $t('shareResource.allClasses') }}
        .class-select.middle(v-for='resClass in modalProps.classesAmount')
          checkbox.m-right-05(:updateCheck='() => selectClass(resClass)' :checked='isClassSelected(resClass)')
          h2.text-normal.blue.bold {{ $t('sidebar.class') + ' ' + resClass }}
    .column.m-top-1.start.platforms-section(:class='{platformsDisabled}')
      h2.text-normal.m-bottom-2 {{ $t('shareResource.selectPlatform') }}
      .row.middle.platforms
        .column.center
          button.platform.row.middle.center(@click='copyLink')
            simple-svg.black-icon(:filepath='linkIcon' width='18px' height='18px')
          h2.text-small.m-top-05 {{ $t('shareResource.platforms.link') }}
        .column.center
          .platform.row.middle.center
            img(v-if='platformsDisabled' :src='googleClassroomIcon' width='18px' height='18px')
            #widget-div(v-else)
          h2.text-small.m-top-05 {{ $t('shareResource.platforms.classroom') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import amplitude from 'amplitude-js'
import linkIcon from '@/assets/ic_link.svg'
import Checkbox from '@/components/Inputs/Checkbox'
import leftArrow from '@/assets/ic_chevron-left.svg'
import dropdownIcon from '@/assets/ic_chevron-down.svg'
import checklistIcon from '@/assets/ic_checklist.svg'
import googleClassroomIcon from '@/assets/ic_google_classroom.png'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  components: { Checkbox },
  data() {
    return {
      googleClassroomIcon,
      leftArrow,
      dropdownIcon,
      checklistIcon,
      linkIcon,
      selectedClasses: [],
      classDropdown: false
    }
  },
  async created() {
    this.getShareableLink(this.resourceId)
  },
  watch: {
    selectedClasses(newValue, oldValue) {
      if (!oldValue.length && newValue.length) {
        this.$nextTick(() => {
          window.gapi.sharetoclassroom.render('widget-div', {
            size: 18,
            theme: 'classic',
            url: this.studentLink
          })
        })
      }
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.shareResourceModal.props,
      resourceId: state => state.resource.resource.id,
      shareToken: state => state.resource.shareToken,
      resourceName: state => state.resource.resource.title,
      innerLang: state => state.behavior.innerLocale,
      resourceAuthor: state => state.resource.resource.author
    }),
    allSelected() {
      return this.selectedClasses.length === this.modalProps.classesAmount
    },
    studentLink() {
      const link = `${window.location.origin}/r/${this.$route.params.id}?verify=${this.shareToken}&locale=${this.innerLang}`
      if (this.allSelected) return link
      else return `${link}&sharedClasses=${this.selectedClasses}`
    },
    platformsDisabled() {
      return !this.selectAll && !this.selectedClasses.length
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'getShareableLink'
    ]),
    isClassSelected(classNumber) {
      return Boolean(this.selectedClasses.includes(classNumber))
    },
    toggleAll() {
      if (this.selectedClasses.length === this.modalProps.classesAmount) {
        this.selectedClasses = []
      } else {
        this.selectedClasses = [...Array(this.modalProps.classesAmount).keys()].map(i => i + 1)
      }
    },
    selectClass(classNumber) {
      if (this.isClassSelected(classNumber)) {
        this.selectedClasses = this.selectedClasses.filter(cn => cn !== classNumber)
      } else {
        this.selectedClasses = [...this.selectedClasses, classNumber]
      }
    },
    copyLink() {
      amplitude.getInstance().logEvent('Get Student Shareable Resource Link', {
        resource: this.resourceName,
        id: this.resourceId
      })
      this.$copyText(this.studentLink)
      this.$emit('showTooltip')
    },
    logStudentView() {
      amplitude.getInstance().logEvent('Student Preview', {
        id: this.resourceId,
        resource: this.resourceName,
        author: this.resourceAuthor.name,
        origin: 'Share Resource Modal'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.share-all{
  max-width: none;
}

.classes{
  flex-wrap: wrap;
  gap: 10px;
  .class-select{
    padding: 5px 10px;
    border-radius: 5px;
    border: 2px solid $blue;
    display: inline-flex;
  }
}

.platforms{
  gap: 20px;
  .platform{
    cursor: pointer;
    padding: 5px;
    border-radius: 50%;
    background-color: $light-gray;
    width: 35px;
    height: 35px;
  }
}

.platforms-section{
  &.platformsDisabled{
    opacity: 0.5;
    .platform{
      cursor: default;
    }
  }
}

#widget-div{
  &.hidden{
    visibility: hidden;
  }
}

.class-dropdown{
  border: 2px solid $blue;
  border-radius: 4px;
  background-color: $white;
  height: 40px;
  min-width: 120px;
  position: relative;
  &.active{
    .dropdown{
      transform: rotate(180deg);
    }
  }
  .dropdown-container{
    position: absolute;
    width: calc(100% + 2px);
    top: calc(100% + 1px);
    border: 1px solid $gray;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: $white;
    .classes{
      max-height: 200px;
      overflow-y: auto;
    }
    .class-option, .get-link{
      padding: 8px;
    }
    .get-link{
      width: 100%;
      border: 1px solid $gray;
      border-top-width: 2px;
      background-color: $lighter-gray;
      &:disabled{
        opacity: 0.6;
        cursor: default;
      }
    }
  }
}
</style>
